import { observer } from 'mobx-react';
import { FC, ReactElement, useCallback } from 'react';
import { InputWithTextInside } from '~/view/components/Controls/Inputs';
import editFAQStore from '~/view/screens/SettingsScreen/screens/OrderingChannel/screens/EditFAQScreen/store/editFAQStore';
import './style.scss';

const EditFAQSort: FC = observer((): ReactElement => {
  const onChangeSort = useCallback((value: string | undefined) => {
    editFAQStore.changeFAQHandler({ sort: Number(value || 0) });
  }, []);

  return (
    <InputWithTextInside
      type="number"
      value={editFAQStore.FAQ.sort}
      onChangeValue={onChangeSort}
      textProps={{ text: 'sort' }}
      contentClassName="edit-faq-sort__input"
    />
  );
});

export default EditFAQSort;
